import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { CheckoutMyPlanComponent } from './my-plan/my-plan.component';
import { CheckoutIdentificationComponent } from './identification/identification.component';
import { CheckoutPaymentComponent } from './payment/payment.component';
import { CheckoutSuccessComponent } from './success/success.component';



import { CheckoutComponent } from './checkout.component';
import {CheckoutMyNewPackageComponent} from './my-new-package/my-new-package.component';
import { CheckoutMyHybridPackageComponent } from './my-hybrid-package/my-hybrid-package.component';
import { CheckoutTimeoutComponent } from './timeout/timeout.component';
import { ChangePlanComponent} from './change-plan/change-plan.component';

export const checkoutRoutes: Routes = [
  {
    path: 'checkout',
    component: CheckoutComponent,
    children: [
      {
        path: 'meu-plano',
        component: CheckoutMyPlanComponent
      },
      {
        path: 'alteracao-plano',
        component: ChangePlanComponent
      },
      {
        path: 'meu-pacote-v2',
        component: CheckoutMyNewPackageComponent
      },
      {
        path: 'meu-pacote',
        component: CheckoutMyNewPackageComponent
      },
      {
        path: 'identificacao',
        component: CheckoutIdentificationComponent
      },
      {
        path: 'pagamento',
        component: CheckoutPaymentComponent
      },
      {
        path: 'sucesso',
        component: CheckoutSuccessComponent
      },
      {
        path: 'processamento',
        component: CheckoutTimeoutComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(checkoutRoutes)
  ],
  exports: [RouterModule]
})

export class CheckoutRoutingModule {}
